import * as React from "react";
import {inject, observer} from "mobx-react";
import type {XyiconFeature} from "../../../../generated/api/base";
import type {Portfolio} from "../../../../data/models/Portfolio";
import type {AppState} from "../../../../data/state/AppState";
import type {TransportLayer} from "../../../../data/TransportLayer";
import type {Navigation} from "../../../../Navigation";
import type {View} from "../../../../data/models/View";
import {ReactUtils} from "../../../utils/ReactUtils";
import {StringUtils} from "../../../../utils/data/string/StringUtils";
import type {NavigationEnum} from "../../../../Enums";

interface ISideBarNavItemProps {
	readonly className?: string;
	readonly feature: XyiconFeature;
	readonly menuNav: NavigationEnum;
	readonly MenuIcon: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string}>;
	readonly menuLabel: string;
	readonly activeNav: string;
	readonly onToggleNavigation: () => void;
	readonly portfolio?: Portfolio;
	readonly appState?: AppState;
	readonly transport?: TransportLayer;
	readonly navigation?: Navigation;
	readonly isOpenByDefault?: boolean;
}

interface ISideBarNavItemStates {
	open?: boolean;
}

@inject("appState")
@inject("transport")
@inject("navigation")
@observer
export class SideBarNavItemV5 extends React.Component<ISideBarNavItemProps, ISideBarNavItemStates> {
	constructor(props: ISideBarNavItemProps) {
		super(props);
		this.state = {
			open: this.props.isOpenByDefault || false,
		};
	}

	private toggleDropDown = () => {
		this.setState((prevState) => ({open: !prevState.open}));
	};

	private onSelectView = (view: View) => {
		const {onToggleNavigation, feature, appState, navigation, portfolio, transport} = this.props;

		const menu = navigation.menus.find((menu) => menu.feature === feature);

		if (menu) {
			if (portfolio) {
				transport.services.localStorage.set(appState.actions.getKeyForLocalStorageSelectedPortfolio(), portfolio.id);
			}
			appState.actions.selectView(view);
			navigation.goApp({
				mainNav: menu.nav,
			});
			onToggleNavigation();
		}
	};

	private onClick = async (link: NavigationEnum) => {
		const {portfolio, onToggleNavigation, navigation} = this.props;

		if (portfolio) {
			await navigation.updatePortfolioRefIdInUrl(portfolio.refId);
		}

		onToggleNavigation();
		navigation.goApp({mainNav: link});
	};

	public override render() {
		const {menuNav, activeNav, MenuIcon, menuLabel, className, feature, appState} = this.props;
		const {open} = this.state;
		const views = appState.views[feature].filter((view) => view.showOnNavigation);

		return (
			<li
				key={menuNav}
				className={ReactUtils.cls(className || "", {navItem: true, open: open})}
			>
				<div className="hbox linkContainer">
					<span
						className={ReactUtils.cls("navLink", {active: menuNav === activeNav})}
						onClick={() => {
							this.onClick(menuNav);
						}}
					>
						<div className="iconContainer">
							<MenuIcon />
						</div>
						{menuLabel}
					</span>
					{views.length !== 0 && (
						<div
							className="toggleContainer"
							onClick={this.toggleDropDown}
						>
							<div className={ReactUtils.cls("dropDownToggle", {open: open})} />
						</div>
					)}
				</div>
				{views.length !== 0 && (
					<ul className={ReactUtils.cls("views", {open: open})}>
						{views
							.toSorted((viewA, viewB) => StringUtils.sortIgnoreCase(viewA.name, viewB.name))
							.map((view) => (
								<li
									key={view.id}
									className="view"
									onClick={(event) => this.onSelectView(view)}
								>
									<span className="viewItem">{view.name}</span>
								</li>
							))}
					</ul>
				)}
			</li>
		);
	}
}
